// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__TrGBd","leftCircle":"styles_leftCircle__HRoUI","circle":"styles_circle__XdsOX","buttonText":"styles_buttonText__1iBeW"};